import { render, staticRenderFns } from "./MyCoupons.vue?vue&type=template&id=6fedd314&"
import script from "./MyCoupons.vue?vue&type=script&lang=ts&"
export * from "./MyCoupons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports